'use client'
import Link from 'next/link'
import { ErrorBoundary as ReactErrorBoundary } from 'react-error-boundary'

function ErrorDisplay() {
  return (
    <div
      role="alert"
      className="flex min-h-screen flex-col items-center justify-center gap-8 bg-white p-4 text-center font-line"
    >
      <h1 className="text-2xl font-bold">เกิดปัญหาขึ้น {':('}</h1>
      <div className="flex items-center gap-4">
        <button
          onClick={() => {
            window.location.reload()
          }}
          className="rounded-xl bg-neutral-800 px-4 py-2 text-white no-underline hover:bg-neutral-900"
        >
          ลองอีกครั้ง
        </button>
        <Link
          href="/"
          className="rounded-xl border border-neutral-200 bg-neutral-50 px-4 py-2 text-neutral-800 no-underline hover:bg-neutral-100"
        >
          กลับไปที่หน้าแรก
        </Link>
      </div>
    </div>
  )
}

export function ErrorBoundary({
  children,
}: Readonly<{ children: React.ReactNode }>) {
  return (
    <ReactErrorBoundary fallback={<ErrorDisplay />}>
      {children}
    </ReactErrorBoundary>
  )
}
